<ng-container *ngIf="controller.sessionUser$ | async; let user">
	<ng-container *ngIf="notification.getDisplay$(user) | async; let display">
		<i class="p-color-primary text-lg {{ display?.icon }}"></i>
		<div class="flex-1">
			<div
				[translate]="display?.title"
				[translateParams]="{
					source: (notification.sourceUser$ | async),
					target: (notification.targetUser$ | async)
				}"
				class="font-medium text-md"
			></div>
			<ng-container
				*ngLet="{
					task: notification.task$ | async,
					module: notification.module$ | async,
					document: notification.document$ | async
				} as n"
			>
				<ng-container
					*ngLet="{
						contact: n.task?.contact$ | async,
						jobOffer: n.task?.jobOffer$ | async,
						modulesName: n.task?.modulesName$ | async,
						participants: n.task?.participants$ | async
					} as taskData"
				>
					<div
						[innerHTML]="
							display?.subtitle
								| translate
									: {
											source: (notification.sourceUser$ | async),
											target: (notification.targetUser$ | async),
											taskDescription:
												n.task?.description
												| translate
													: {
															contact: taskData.contact,
															jobOffer: taskData.jobOffer,
															participantsName:
																taskData.participants
																| usersName: (controller.sessionUserId$ | async),
															modulesName: taskData.modulesName,
															date: (n.task?.dueDate | userDate: 'LT' | async)
													  },
											dueDate: (n.task?.dueDate | userDate: 'll' | async),
											date: (notification.meeting?.startDate | userDate: 'llll' | async),
											documentName: (n.document?.localization$ | async)?.name,
											contactsName: notification.contactsName.join(', '),
											moduleName: (n.module?.localization$ | async)?.name
									  }
						"
						class="
							content-subtitle
							p-color-text-secondary
							whitespace-pre-line
							break-all
						"
					></div>
				</ng-container>
			</ng-container>
		</div>
		<div
			class="
				notification-actions
				group-hover:flex
				hidden
				rounded-r
				top-px
				right-px
				bottom-px
				absolute
				flex-wrap
				mr-0
				ml-0
				mt-0
				items-center
				bg-white
				before:absolute before:w-20 before:content-empty before:bg-gradient-to-r
				from-transparent
				to-white
				before:top-0 before:bottom-0 before:right-full
			"
		>
			<button
				*ngIf="display?.actionIcon"
				(click)="onNotificationActionClick(user)"
				class="p-button-primary-transparent text-lg"
				icon="{{ display?.actionIcon }}"
				pButton
			></button>
			<button
				*ngIf="notification.isClosable()"
				(click)="onNotificationCloseClick()"
				class="p-button-primary-transparent text-lg"
				icon="far fa-times-circle"
				pButton
			></button>
		</div>
	</ng-container>
</ng-container>
